import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/carbonEnLogo.png'
import _imports_1 from '../assets/carbonLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-5642e9dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "common-layout-body-header-logo" }
const _hoisted_3 = {
  key: 0,
  class: "common-layout-body-header-logoEnImg",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "common-layout-body-header-logoImg",
  src: _imports_1
}
const _hoisted_5 = { class: "common-layout-body-header-menu" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "common-layout-body-header-userLanguage" }
const _hoisted_8 = {
  class: "languageSelect",
  style: {"width":"110px"}
}
const _hoisted_9 = { class: "languageSelect" }
const _hoisted_10 = { class: "common-layout-body-header-userInfo" }
const _hoisted_11 = { class: "showUserNameEn" }
const _hoisted_12 = { class: "userName" }
const _hoisted_13 = { class: "common-layout-body-nav-body" }
const _hoisted_14 = { class: "common-layout-Breadcrumb" }
const _hoisted_15 = { class: "common-org-message" }
const _hoisted_16 = { class: "common-layout-body-nav-main" }

import { Document, Menu as IconMenu, Location, Setting } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
import { ref, reactive, computed, inject, onMounted, onBeforeMount, watch } from 'vue';
import { useStore } from 'vuex';
import Pinyin from 'js-pinyin';
import { useI18n } from 'vue-i18n';
import auth from '../api/auth';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const { locale } = useI18n();

const store = useStore();
let defaultActive = ref(window.location.hash.replace('#', ''));
const router = useRouter();
console.log(router, 'router');

const entryClick = (path) => {
  defaultActive.value = path;
};

const routerMenuList: any = router.options.routes;
let menuList: any = ref([]);

// 给routerview绑定一个值，用来判断面包屑点击的相应，然后各页面自行判断是否要做页面的回退、销毁等的操作
const clickedbreadCrumb = ref(0);
// 运营的返回按钮要屏蔽
const isShow = () => {
  if (
    route.fullPath.indexOf('/operate') > -1 ||
    route.fullPath.indexOf('/workbench') > -1 ||
    route.fullPath.indexOf('/userInfo') > -1 ||
    route.fullPath == '/' ||
    route.fullPath == '/ProjectEmissionReduction/Project_OAA/Reduce_GAS' ||
    route.fullPath.indexOf('/foxconn') > -1
  ) {
    return false;
  }
  return true;
};

const onBreadCrumbClick = (e) => {
  clickedbreadCrumb.value += 1;
  // 判断是否是从看板选中跳转的，如果是 此时点返回要返回看板
  if (jumpFromDashBoardPage) {
    const dashbordPath = '/';
    router.push({ path: dashbordPath });
    defaultActive.value = dashbordPath;
    isInDashBordPage.value = true;
    jumpFromDashBoardPage = false;
  }
};

// 判断是否在看板页面
let isInDashBordPage = ref(false);
// 判断是否从看板跳转到 目标管理的各个子页面，添加返回按钮的回退事件
let jumpFromDashBoardPage = false;

// 看板跳转
const dashBoardJump = (keyPath: string[]) => {
  // 手动设置menu的选中项  这里el-menu-item的index用的是path，所以此处也取传的子路径的path
  jumpFromDashBoardPage = true;
  isInDashBordPage.value = false;
  defaultActive.value = keyPath[1];
};

const handleSelect = (key, keyPath) => {
  defaultActive.value = key;
  checkTokenValid();
};

// 此处要获取当前员工的权限，来区分显示人员所属是 -> 中央/事业群/全区
const staffOrganization = ref('');

const userName = ref('');

const language = ref(store.state.language);
const renovate = inject('reload');
const changeLang = (lang: string) => {
  store.commit('changeLanguage', lang);
  locale.value = lang;
  router.go(0);
  // localStorage.setItem('lang', lang); // 重要！下面遇到问题里解释
  // renovate(); // 只重新加载数据 无法切换element-plus语言
  // location.reload(); // 切换element-plus语言但是页面会有空白期限
};
const goToUser = () => {
  router.push({ path: '/userInfo' });
};

const handleCommand = (command) => {
  if (command === 'user') {
    router.push({ path: '/userInfo' });
  } else {
    loginOut();
  }
};

const getInitial = computed(() => {
  const username = userName.value;
  if (!username) return;
  const pattern = new RegExp('[\u4E00-\u9FA5]+');
  if (pattern.test(username.substring(0, 1))) {
    const py = Pinyin.getFullChars(username.substring(0, 1));
    return py && py.substring(0, 1);
  } else {
    return username.substring(0, 1);
  }
});

const getTokenPass = async () => {
  const tokenPass = await auth.tokenPass();
  if (tokenPass.code === 1011008) {
    loginIn();
  } else {
    return true;
  }
};

const getToken = () => {
  const relToken = store.state.token;
  userName.value = store.state.user.userInfo.name;
  staffOrganization.value = store.state.organizationInfo.title ?? '';
  if (relToken) {
    return getTokenPass();
  } else {
    loginIn();
  }
};

const checkTokenValid = () => {
  const relToken = store.state.token;
  if (relToken) {
    getTokenPass();
  } else {
    loginIn();
  }
};

// 跳转登录页面
const loginIn = () => {
  router.push({ path: '/login' });
};

const loginOut = () => {
  // 暂时改成 不用等待登出接口调用成功才回到登录页面
  const getLoginOut = auth.loginOut();
  store.commit('changeToken', '');
  // store.commit('changeUserInfo', {});
  store.commit('changeLoginStatus', false);
  loginIn();
};

const routerBreadcrumb = ref([]);
// 监听当前路由
watch(
  () => router.currentRoute.value,
  (newValue, oldValue) => {
    if (newValue.matched.length >= 1 && newValue.matched[0].path == '/') {
      routerBreadcrumb.value = [newValue.matched[1]];
    } else {
      routerBreadcrumb.value = newValue.matched;
    }
  },
  { immediate: true, deep: true }
);

// 根据登录返回的菜单权限 动态显示 menuList
const getMenuList = async () => {
  const userInfo = store.state.user.userInfo;
  // console.log('🚀 ~ getMenuList ~ userInfo:', userInfo);
  // menuList.value = routerMenuList;
  // 超级管理员拥有全部菜单
  if (userInfo.adminType === 1) {
    menuList.value = routerMenuList;
  } else {
    menuList.value = await getMenuListFromUserMenu(JSON.parse(JSON.stringify(routerMenuList)), userInfo.menus || []);
    // console.log('🚀 ~ getMenuList ~ menuList.value:', menuList.value);
  }
  // if (userInfo.adminType === 1) {
  //   menuList.value = routerMenuList;
  // } else {
  //   const userMenus = userInfo.menus ?? [];
  //   console.log(userMenus, 'userMenus');
  //   if (userMenus.length > 0) {
  //     const res = await getMenuListFromUserMenu(userMenus || []);
  //     Object.assign(menuList.value, res);
  //   }
  // }
};

// 根据返回的菜单管理权限，动态显示 menuList，需要对配置菜单有一定要求
const getMenuListFromUserMenu = async (menus, userMenus) => {
  // console.log('🚀 ~ menus.forEach ~ menus:', menus);
  menus.forEach(async (menu) => {
    const isHaveAuthority = userMenus.find((item) => item.name === menu.name);
    if (isHaveAuthority) {
      menu.hidden = false;
    } else {
      menu.hidden = true;
    }
    if (menu.children && menu.children.length > 0) {
      menu.children = await getMenuListFromUserMenu(menu.children, userMenus);
    }
  });
  return menus;
};
// // 动态配置菜单，用path去和返回的menu去做比较，有就显示
// // 这里先就这么写，虽然看上去比较蠢，但是后台返回的menu配置不能直接用，还是本地定义好做判断比较合适
// const dashBoardMenu = {
//   path: '/',
//   name: 'layout',
//   redirect: '/',
//   children: [
//     {
//       path: '/',
//       name: 'index',
//       meta: { title: 'menu.homePage', zhTitle: '看板', icon: 'House' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/dataBoard/index.vue'),
//     },
//   ],
//   hidden: false,
// };

// const manageMentMenu = {
//   path: '/Management_by_objectives',
//   name: 'Management_by_objectives',
//   redirect: '/Management_by_objectives/index',
//   meta: { title: 'menu.Management_by_objectives', zhTitle: '目标管理', icon: 'DataAnalysis' },
//   children: [
//     {
//       path: 'Goal_SAD',
//       name: 'Goal_SAD',
//       meta: {
//         title: 'menu.Management_by_objectives_children.Goal_setting_and_decomposition',
//         zhTitle: '目标设定与分解',
//       },
//       children: [
//         {
//           path: 'Absolute_Control',
//           name: 'Absolute_Control',
//           meta: {
//             title: 'menu.Management_by_objectives_children.Absolute_control_Goal',
//             zhTitle: '绝对控排目标',
//           },
//           component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/control.vue'),
//         },
//         {
//           path: 'Project_Goal',
//           name: 'Project_Goal',
//           meta: {
//             title: 'menu.Management_by_objectives_children.Project_emission_reduction_Goal',
//             zhTitle: '专案减排目标',
//           },
//           component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/projectGoal.vue'),
//         },
//       ],
//     },
//     {
//       path: 'Absolute_CASOAA',
//       name: 'Absolute_CASOAA',
//       meta: {
//         title: 'menu.Management_by_objectives_children.Absolute_control_and_scheduling_objectives_and_achievement',
//         zhTitle: '绝对控排目标与达成',
//       },
//       component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/absoluteControl.vue'),
//     },
//     {
//       path: 'Project_OAA',
//       name: 'Project_OAA',
//       meta: {
//         title: 'menu.Management_by_objectives_children.Project_objectives_and_achievement',
//         zhTitle: '专案目标与达成情况',
//       },
//       children: [
//         {
//           path: 'Project',
//           name: 'Project',
//           meta: {
//             title: 'menu.Management_by_objectives_children.Project_objectives_and_achievement',
//             zhTitle: '专案目标与达成情况',
//           },
//           component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/projectControl.vue'),
//         },
//         {
//           path: 'Reduce_GAS',
//           name: 'Reduce_GAS',
//           meta: {
//             title: 'menu.Management_by_objectives_children.Reduce_Goal_Achievement_Status',
//             zhTitle: 'Reduce目标达成情况',
//           },
//           component: () =>
//             import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/reduceGoalStatus/index.vue'),
//         },
//       ],
//     },
//     {
//       path: 'Project_ERPC',
//       name: 'Project_ERPC',
//       meta: {
//         title: 'menu.Management_by_objectives_children.Project_emission_reduction_progress_control',
//         zhTitle: '专案减排进度管控',
//       },
//       component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/projectProgress.vue'),
//     },
//   ],
//   hidden: false,
// };

// const operateMenu = {
//   path: '/operate',
//   name: 'operate',
//   redirect: '/operate/index',
//   meta: { title: 'menu.operate', zhTitle: '运营', icon: 'DataAnalysis' },
//   children: [
//     {
//       path: 'ProjectManagement',
//       name: 'ProjectManagement',
//       meta: { title: 'menu.operate_children.Project_management', zhTitle: '专案管理' },
//       children: [
//         {
//           path: 'ProjectList',
//           name: 'ProjectList',
//           meta: { title: 'menu.operate_children.Project_management_children.Project_list', zhTitle: '专案列表' },
//           component: () => import(/* webpackChunkName: "about" */ '../views/projectManage/projectList.vue'),
//         },
//       ],
//     },
//     {
//       path: 'orgManage',
//       name: 'orgManage',
//       meta: { title: 'menu.operate_children.organizational_management', zhTitle: '机构管理' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/orgManage.vue'),
//     },
//     {
//       path: 'accountManage',
//       name: 'accountManage',
//       meta: { title: 'menu.operate_children.account_management', zhTitle: '账号管理' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/accountManage.vue'),
//     },
//     {
//       path: 'roleManage',
//       name: 'roleManage',
//       meta: { title: 'menu.operate_children.Role_management', zhTitle: '角色管理' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/roleManage.vue'),
//     },
//     {
//       path: 'menuManage',
//       name: 'menuManage',
//       meta: { title: 'menu.operate_children.Menu_management', zhTitle: '菜单管理' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/menuManage.vue'),
//     },
//     {
//       path: 'carbonButler',
//       name: 'carbonButler',
//       meta: { title: 'menu.operate_children.carbon_butler', zhTitle: '碳管家' },
//       children: [
//         {
//           path: 'factor',
//           name: 'factor',
//           meta: { title: 'menu.operate_children.carbon_butler_children.Factor_maintenance', zhTitle: '因子维护' },
//           component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/backStage/factor.vue'),
//         },
//         {
//           path: 'exchangeRate',
//           name: 'exchangeRate',
//           meta: { title: 'menu.operate_children.carbon_butler_children.Exchange_rate_table', zhTitle: '基础汇率表' },
//           component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/backStage/exchangeRate.vue'),
//         },
//         {
//           path: 'inventoryTask',
//           name: 'inventoryTask',
//           meta: { title: 'menu.operate_children.carbon_butler_children.inventory_Task', zhTitle: '盘查任务' },
//           component: () =>
//             import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/carbonInventory.vue'),
//         },
//         {
//           path: 'inventoryProject',
//           name: 'inventoryProject',
//           meta: {
//             title: 'menu.operate_children.carbon_butler_children.inventory_Project',
//             zhTitle: 'inventory_Project',
//           },
//           component: () =>
//             import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/projectInventory.vue'),
//         },
//       ],
//     },
//   ],
//   hidden: false,
// };

// const workbenchMenu = {
//   path: '/workbench',
//   name: 'workbench',
//   redirect: '/workbench/index',
//   meta: { title: 'menu.workbench', zhTitle: '工作台', icon: 'DataAnalysis' },
//   children: [
//     {
//       path: 'TodoList',
//       name: 'TodoList',
//       meta: { title: 'menu.workbench_children.To_do_list', zhTitle: '待办列表' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/workbench/index.vue'),
//     },
//     {
//       path: 'HistoryNotification',
//       name: 'HistoryNotification',
//       meta: { title: 'menu.workbench_children.History_notification', zhTitle: '历史通知' },
//       component: () => import(/* webpackChunkName: "about" */ '../views/workbench/index.vue'),
//     },
//   ],
//   hidden: false,
// };

// 按照权限菜单
// const getMenuListFromUserMenu = async (userMenus) => {
//   let finalMenuList = [];
//   userMenus.forEach((item1) => {
//     if (item1.path == '/') {
//       finalMenuList.push(dashBoardMenu);
//     } else if (item1.path.indexOf('Management_by_objectives') >= 0) {
//       let menu = JSON.parse(JSON.stringify(manageMentMenu));
//       menu.children = [];
//       userMenus.forEach((item2) => {
//         if (item2.path.indexOf('Project_ERPC') >= 0) {
//           menu.children.push(manageMentMenu.children[3]);
//         } else if (item2.path.indexOf('Project_OAA') >= 0) {
//           let projectData = JSON.parse(JSON.stringify(manageMentMenu.children[2]));
//           projectData.children = [];
//           userMenus.forEach((item3) => {
//             if (item3.path === '/Project') {
//               projectData.children.push(manageMentMenu.children[2].children[0]);
//             } else if (item3.path.indexOf('Reduce_GAS') >= 0) {
//               projectData.children.push(manageMentMenu.children[2].children[1]);
//             }
//           });
//           menu.children.push(projectData);
//         } else if (item2.path.indexOf('Absolute_CASOAA') >= 0) {
//           menu.children.push(manageMentMenu.children[1]);
//         } else if (item2.path.indexOf('Goal_SAD') >= 0) {
//           let goalData = JSON.parse(JSON.stringify(manageMentMenu.children[0]));
//           goalData.children = [];
//           userMenus.forEach((item3) => {
//             if (item3.path.indexOf('Absolute_Control') >= 0) {
//               goalData.children.push(manageMentMenu.children[0].children[0]);
//             } else if (item3.path.indexOf('Project_Goal') >= 0) {
//               goalData.children.push(manageMentMenu.children[0].children[1]);
//             }
//           });
//           menu.children.push(goalData);
//         }
//       });
//       finalMenuList.push(menu);
//     } else if (item1.path.indexOf('operate') >= 0) {
//       let menu = JSON.parse(JSON.stringify(operateMenu));
//       menu.children = [];
//       userMenus.forEach((item2) => {
//         if (item2.path.indexOf('menuManage') >= 0) {
//           menu.children.push(operateMenu.children[4]);
//         } else if (item2.path.indexOf('roleManage') >= 0) {
//           menu.children.push(operateMenu.children[3]);
//         } else if (item2.path.indexOf('accountManage') >= 0) {
//           menu.children.push(operateMenu.children[2]);
//         } else if (item2.path.indexOf('orgManage') >= 0) {
//           menu.children.push(operateMenu.children[1]);
//         } else if (item2.path.indexOf('carbonButler') >= 0) {
//           menu.children.push(operateMenu.children[5]);
//         } else if (item2.path.indexOf('ProjectManagement') >= 0) {
//           let projectManagementData = JSON.parse(JSON.stringify(operateMenu.children[0]));
//           projectManagementData.children = [];
//           userMenus.forEach((item3) => {
//             if (item3.path.indexOf('ProjectList') >= 0) {
//               projectManagementData.children.push(operateMenu.children[0].children[0]);
//             }
//           });
//           menu.children.push(projectManagementData);
//         }
//       });
//       finalMenuList.push(menu);
//     } else if (item1.path.indexOf('workbench') >= 0) {
//       let menu = JSON.parse(JSON.stringify(workbenchMenu));
//       menu.children = [];
//       userMenus.forEach((item2) => {
//         if (item2.path.indexOf('TodoList') >= 0) {
//           menu.children.push(workbenchMenu.children[0]);
//         }
//         // else if (item2.path.indexOf('HistoryNotification') >= 0) {
//         //   menu.children.push(workbenchMenu.children[1]);
//         // }
//       });
//       menu.children.reverse();
//       finalMenuList.push(menu);
//     }
//   });
//   return finalMenuList.reverse();
// };

onBeforeMount(() => {
  getMenuList();
  getToken();
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "common-layout-body" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { class: "common-layout-body-header" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (language.value == 'en')
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : (_openBlock(), _createElementBlock("img", _hoisted_4))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_menu, {
                class: "el-menu-demo",
                mode: "horizontal",
                "text-color": "#86909C",
                "default-active": _unref(defaultActive),
                "active-text-color": "#3772ff",
                router: "true",
                onSelect: handleSelect
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (parent, pIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: pIndex }, [
                      (!parent.hidden && parent.name !== 'userInfo')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (!parent.meta)
                              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: 0,
                                  index: parent.children[0].path,
                                  style: {"padding":"0 15px 0 10px"}
                                }, {
                                  default: _withCtx(() => [
                                    (parent.children[0].meta.icon)
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 0,
                                          title: parent.children[0].meta.icon
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, {
                                              name: parent.children[0].meta.icon
                                            }, null, 8, ["name"])
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(parent.children[0].meta.title)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                                  key: 1,
                                  index: parent.path
                                }, {
                                  title: _withCtx(() => [
                                    (parent.meta.icon)
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 0,
                                          title: parent.meta.icon
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, {
                                              name: parent.meta.icon
                                            }, null, 8, ["name"])
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(parent.meta.title)), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parent.children, (children, cIndex) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: cIndex }, [
                                        (children.children && !children.hidden)
                                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                              key: 0,
                                              index: parent.path + '/' + children.path
                                            }, {
                                              title: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(children.meta.title)), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children.children, (cchildren, ccIndex) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: ccIndex }, [
                                                    (!cchildren.hidden)
                                                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                                          key: 0,
                                                          index: parent.path + '/' + children.path + '/' + cchildren.path
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t(cchildren.meta.title)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["index"]))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["index"]))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              (!children.hidden)
                                                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                                    key: 0,
                                                    index: parent.path + '/' + children.path
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t(children.meta.title)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["index"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                      ], 64))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_select, {
                    modelValue: language.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
                    class: "m-2 screenSelect",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (changeLang(language.value))),
                    placeholder: "简体中文",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "简体中文",
                        value: "zh",
                        style: {"display":"flex","align-items":"center"}
                      }),
                      _createVNode(_component_el_option, {
                        label: "English",
                        value: "en",
                        style: {"display":"flex","align-items":"center"}
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_dropdown, {
                  onCommand: handleCommand,
                  "popper-class": "userInfo"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(userName.value), 1),
                        _createVNode(_component_el_dropdown_item, {
                          style: {"height":"30px","display":"flex","justify-content":"center","margin-top":"-5px","padding":"5px 0"},
                          command: "user",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (goToUser()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('menu.user')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          style: {"height":"30px","display":"flex","justify-content":"center","margin-top":"-5px","padding":"5px 0"},
                          command: "logout"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('menu.logout')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getInitial)), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_breadcrumb, { separator: "/" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerBreadcrumb.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: index }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(item.meta.title)), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('userInfo.Affiliated_organization')) + "：" + _toDisplayString(staffOrganization.value), 1)
          ]),
          _createVNode(_component_el_container, { class: "common-layout-body-nav" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component }) => [
                    (_openBlock(), _createBlock(_KeepAlive, { include: "FoxconnProject" }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        clickedbreadCrumb: clickedbreadCrumb.value,
                        onDashBoardJump: dashBoardJump,
                        onEntryClick: entryClick
                      }, null, 40, ["clickedbreadCrumb"]))
                    ], 1024))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})